export const GitlabIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_396_256)">
      <path
        d="M20.5422 7.91642L20.5141 7.84175L17.6772 0.468478C17.6198 0.323702 17.5176 0.200887 17.3855 0.117813C17.2869 0.0549297 17.1749 0.015934 17.0584 0.00395111C16.942 -0.0080318 16.8244 0.00733192 16.715 0.0488106C16.6055 0.0902892 16.5074 0.156729 16.4284 0.242805C16.3494 0.328881 16.2918 0.432199 16.2601 0.544477L14.3451 6.38576H6.59035L4.67541 0.544477C4.64347 0.432367 4.58567 0.329243 4.50664 0.243332C4.42761 0.157421 4.32952 0.0910987 4.2202 0.0496539C4.11088 0.00820906 3.99336 -0.00721145 3.87699 0.00462249C3.76063 0.0164564 3.64866 0.0552169 3.55 0.117813C3.41787 0.200887 3.31569 0.323702 3.25827 0.468478L0.422661 7.84309L0.393221 7.91642C-0.0150237 8.97948 -0.065318 10.146 0.24992 11.24C0.565158 12.3341 1.22884 13.2963 2.14089 13.9817L2.1516 13.9897L2.17568 14.0084L6.49132 17.231L8.63242 18.843L9.93313 19.823C10.0857 19.9379 10.2718 20 10.4631 20C10.6543 20 10.8404 19.9379 10.993 19.823L12.2937 18.843L14.4348 17.231L18.7812 13.9897L18.7932 13.9804C19.7052 13.2952 20.369 12.3333 20.6845 11.2395C20.9999 10.1458 20.95 8.97945 20.5422 7.91642Z"
        fill="#E24329"
      />
      <path
        d="M20.5424 7.91642L20.5143 7.84175C19.132 8.12436 17.8297 8.70807 16.7004 9.55107L10.4712 14.2444L14.4376 17.231L18.784 13.9897L18.796 13.9804C19.7076 13.2949 20.3708 12.3328 20.6858 11.239C21.0008 10.1453 20.9504 8.97917 20.5424 7.91642Z"
        fill="#FC6D26"
      />
      <path
        d="M6.49121 17.231L8.6323 18.843L9.93302 19.823C10.0856 19.9379 10.2717 20 10.4629 20C10.6542 20 10.8402 19.9379 10.9929 19.823L12.2936 18.843L14.4347 17.231L10.4683 14.2444L6.49121 17.231Z"
        fill="#FCA326"
      />
      <path
        d="M4.23515 9.55106C3.10633 8.70849 1.80438 8.12522 0.422661 7.84308L0.393221 7.91641C-0.0150237 8.97948 -0.065318 10.146 0.24992 11.24C0.565158 12.334 1.22884 13.2963 2.14089 13.9817L2.1516 13.9897L2.17568 14.0084L6.49132 17.231L10.4604 14.2444L4.23515 9.55106Z"
        fill="#FC6D26"
      />
    </g>
    <defs>
      <clipPath id="clip0_396_256">
        <rect
          width="20.9091"
          height="20"
          fill="white"
          transform="translate(0.0454102)"
        />
      </clipPath>
    </defs>
  </svg>
);
